export enum ListenerType {
  UserCommentModerationMap = 'user-comment-moderation-map',
  CommunityCommentModerationMap = 'community-comment-moderation-map',
  CommentMap = 'comment-map',
  UserThreadModerationMap = 'user-thread-moderation-map',
  CommunityThreadModerationMap = 'community-thread-moderation-map',
  ThreadMap = 'thread-map',
}
